import React, { useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import type { PickingItem } from '../../../services/pickingVentaService';
import { formatCantidadPicking } from '../pickingHelpers';

interface PickingDeshacerDialogProps {
  item: PickingItem | null;
  loading: boolean;
  onClose: () => void;
  onConfirm: (item: PickingItem, cantidad: number) => void;
}

const PickingDeshacerDialog: React.FC<PickingDeshacerDialogProps> = ({ item, loading, onClose, onConfirm }) => {
  const [cantidad, setCantidad] = useState('');

  useEffect(() => {
    if (item) setCantidad(String(item.cantidadPickeada));
  }, [item]);

  const valor = Number(cantidad.replace(',', '.'));
  const maximo = item?.cantidadPickeada ?? 0;
  const invalido = !Number.isFinite(valor) || valor <= 0 || valor > maximo;

  const confirmar = () => {
    if (item && !invalido && !loading) onConfirm(item, valor);
  };

  return (
    <Dialog open={Boolean(item)} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Deshacer lectura</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          <strong>{item?.codigoArticulo}</strong> — {item?.descripcion}
          <br />
          Pickeado: {formatCantidadPicking(maximo)}
        </Typography>
        <TextField
          autoFocus
          fullWidth
          label="Cantidad a deshacer"
          type="number"
          value={cantidad}
          onChange={(e) => setCantidad(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') confirmar();
          }}
          error={cantidad !== '' && invalido}
          helperText={cantidad !== '' && invalido ? `Ingresá un valor entre 0 y ${formatCantidadPicking(maximo)}` : ' '}
          inputProps={{ min: 0, max: maximo, step: 'any' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancelar</Button>
        <Button
          variant="contained"
          color="warning"
          onClick={confirmar}
          disabled={invalido || loading}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          Deshacer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PickingDeshacerDialog;
